import type { ReactNode } from 'react';
import { ArrowTopRight2 } from 'assets/icons/ArrowTopRight2';
import CustomLink from 'components/shared/CustomLink';
import styles from './ArrowLink.module.css';

/* The text link with an up-right arrow that closes a section intro. */
export const ArrowLink = ({
  href,
  buttonType,
  children,
}: {
  href: string;
  /** analytics `data-buttontype` */
  buttonType: string;
  children: ReactNode;
}) => (
  <CustomLink href={href} className={styles.link} data-buttontype={buttonType}>
    <span className={styles.label}>{children}</span>
    <ArrowTopRight2 className={styles.icon} aria-hidden />
  </CustomLink>
);
